import api from 'api'
import { z } from 'zod'

export const linkDayforceShiftRequestSchema = z.object({
  agencyId: z.string().uuid(),
  jobId: z.string().uuid(),
  bookingId: z.string().uuid(),
  shiftId: z.coerce.string(),
  associationType: z.string(),
})

const linkDayforceShiftResponseSchema = z.object({}).passthrough()

export type LinkDayforceShiftRequest = z.infer<
  typeof linkDayforceShiftRequestSchema
>

export const linkDayforceShift = async (
  request: LinkDayforceShiftRequest
): Promise<void> => {
  const parsedRequest = linkDayforceShiftRequestSchema.parse(request)

  const response = await api.post('/admin/dayforce/associate_booking', {
    agencyId: parsedRequest.agencyId,
    jobId: parsedRequest.jobId,
    bookingId: parsedRequest.bookingId,
    shiftId: parsedRequest.shiftId,
    associationType: parsedRequest.associationType,
  })

  linkDayforceShiftResponseSchema.parse(response.data)
}
